import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import {Box, ButtonGroup, Stack} from '@mui/material';
import {OptionType} from "@/model/global";

export interface TotalSummaryProps {
    option: OptionType
}

export default function TotalSummary({option}: TotalSummaryProps) {
    return (
        <Card sx={{height: '100%', position: 'relative'}}>
            <CardContent sx={{
                height: 120,
                flexGrow: 1, "&:before": {
                    content: "''",
                    position: 'absolute',
                    right: 0,
                    left: 'unset',
                    width: '100%',
                    height: '100%',
                    background: 'url(https://oss.kedaip.cn/keda/assets/mission.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'top 0px left 168px'
                }
            }}>
                <Stack direction='column' height={'inherit'} justifyContent={'space-between'} spacing={1}>
                    <Box display={'flex'} flexDirection={'column'} gap={0.2}>
                        <Stack direction="row" justifyContent={'space-between'} spacing={1}>
                            <Typography
                                component="h2"
                                variant="subtitle2"
                                gutterBottom
                                sx={{fontWeight: '600'}}
                            >
                                全部{option.label}
                            </Typography>
                            <InsightsRoundedIcon fontSize={'large'}/>
                        </Stack>
                        <Stack direction={'row'} justifyContent={'space-between'} alignContent={'center'} alignItems={'center'}>
                            <Typography variant="h5" component="p">485个</Typography>
                            <Typography variant="subtitle2" component="p">最近新增12个{option.label}</Typography>
                        </Stack>

                    </Box>
                    <ButtonGroup variant="outlined" size={'small'}>
                        <Button>
                            <Stack width={60} direction={'column'} justifyContent={'space-between'} alignItems={'center'}>
                                <Typography component={'span'} fontSize={11} fontWeight={'bold'}>238个</Typography>
                                <Typography component={'span'} fontSize={10}>最近新增</Typography>
                            </Stack>
                        </Button>
                        <Button>
                            <Stack width={60} direction={'column'} justifyContent={'space-between'} alignItems={'center'}>
                                <Typography component={'span'} fontSize={11} fontWeight={'bold'}>32%</Typography>
                                <Typography component={'span'} fontSize={10}>完成率</Typography>
                            </Stack>
                        </Button>
                    </ButtonGroup>
                </Stack>
            </CardContent>
        </Card>
    );
}
